// Google Analytics 4 — loaded immediately (no cookie gate, per user decision)
// To activate, set REACT_APP_GA_ID=G-XXXXXXXXXX in /app/frontend/.env then rebuild.
// If REACT_APP_GA_ID is empty or missing, no GA script is loaded (zero overhead).

const GA_ID = process.env.REACT_APP_GA_ID || "";
let loaded = false;

export function initAnalytics() {
  if (!GA_ID || loaded || typeof window === "undefined") return;
  loaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", GA_ID, { send_page_view: true, anonymize_ip: true });
}

export function trackPageView(path) {
  if (!GA_ID || typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.origin + path,
    page_title: document.title,
  });
}

export function trackEvent(name, params = {}) {
  if (!GA_ID || typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", name, params);
}

export const GA_ENABLED = !!GA_ID;
